import Component from '@ember/component';
import { action, get, getProperties, set } from '@ember/object';
import { service } from '@ember/service';
import logger from 'donor-elf-web/lib/logger';

/*
  attrs
    - contact
    - group
    - onAddedToGroup(contact)
*/

export default Component.extend({
  tagName: 'tr',
  contactsCache: service(),
  fundsService: service(),

  contact: null,
  group: null,

  adding: false,

  add: action(function () {
    set(this, 'adding', true);
    let { contact, group, contactsCache, fundsService, onAddedToGroup } =
      getProperties(
        this,
        'contact',
        'group',
        'contactsCache',
        'fundsService',
        'onAddedToGroup',
      );
    get(contact, 'groups').push(group);
    fundsService.confirmValidFundToken().then(() => {
      contact.save().then(
        () => {
          contactsCache.incrementProperty('groupsCacheIndex');
          if (onAddedToGroup) {
            onAddedToGroup(contact);
          }
        },
        (error) => {
          logger.error(error);
        },
      );
    });
  }),
});
